import React from 'react';
import Iframe from 'react-iframe';
import { DisplayContainer, Section } from '../../components';
import { images } from './config';
import '../index.scss';

const Model = () => {
  return (
    <Section
      title='3d modeling'
    >
      <DisplayContainer
        images={images}
      />
      {/* <div class='sketchfab-embed-wrapper'>
        <iframe title='parthenon' frameborder='0' allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true' allow='autoplay; 
        fullscreen; 
        xr-spatial-tracking' xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share width='450' height='300' src='https://sketchfab.com/models/2b3f6876454642e1bac3d078c8fc9482/embed'>
        </iframe>
        <p>
          <a href='https://sketchfab.com/3d-models/parthenon-2b3f6876454642e1bac3d078c8fc9482?utm_medium=embed&utm_campaign=share-popup&utm_content=2b3f6876454642e1bac3d078c8fc9482'
            target='_blank' >
            parthenon
          </a>
          by
          <a href='https://sketchfab.com/moreminttea?utm_medium=embed&utm_campaign=share-popup&utm_content=2b3f6876454642e1bac3d078c8fc9482'
            target='_blank' >
            moreminttea
          </a>
          on
          <a href='https://sketchfab.com?utm_medium=embed&utm_campaign=share-popup&utm_content=2b3f6876454642e1bac3d078c8fc9482'
            target='_blank' >
            Sketchfab
          </a>
        </p>
      </div>
      <div className='model_showcase'>
        <Iframe
          title='parthenon'
          frameborder='0'
          allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true'
          allow='autoplay; fullscreen; xr-spatial-tracking'
          xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share
          width='420' height='270'
          src='https://sketchfab.com/models/2b3f6876454642e1bac3d078c8fc9482/embed'>
        </Iframe>
        <Iframe
          title='samurai helmet'
          frameborder='0'
          allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true'
          allow='autoplay; fullscreen; xr-spatial-tracking'
          xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share
          width='420' height='270'
          src='https://sketchfab.com/models/a315a055e13041dbbbc7a04e5165d1dd/embed'>
        </Iframe>
        <Iframe
          title='flying ship'
          frameborder='0'
          allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true'
          allow='autoplay; fullscreen; xr-spatial-tracking'
          xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share
          width='420' height='270'
          src='https://sketchfab.com/models/6f6435fa80f542568774678eedcb8571/embed'>
        </Iframe>
      </div> */}
    </Section>
  )
}

export default Model;

/*
<div class='sketchfab-embed-wrapper'> 
        <iframe style='border: 4px solid #d7ddde; background-color: #F2F2F2; padding: 2%; margin: 15px 15px 0px 15px;' title='parthenon' frameborder='0' allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true' allow='autoplay; 
        fullscreen; 
        xr-spatial-tracking' xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share width='450' height='300' src='https://sketchfab.com/models/2b3f6876454642e1bac3d078c8fc9482/embed'> 
        </iframe> 
        <p style='font-size: 13px; font-weight: normal; margin: 5px; color: #4A4A4A;'> 
          <a href='https://sketchfab.com/3d-models/parthenon-2b3f6876454642e1bac3d078c8fc9482?utm_medium=embed&utm_campaign=share-popup&utm_content=2b3f6876454642e1bac3d078c8fc9482' 
          target='_blank' style='font-weight: bold; color: #272445; margin: 10px 0px 0px 10px;'> 
          parthenon 
          </a> 
            by 
          <a href='https://sketchfab.com/moreminttea?utm_medium=embed&utm_campaign=share-popup&utm_content=2b3f6876454642e1bac3d078c8fc9482' 
          target='_blank' style='font-weight: bold; color: #272445;'> 
            moreminttea 
          </a> 
            on 
          <a href='https://sketchfab.com?utm_medium=embed&utm_campaign=share-popup&utm_content=2b3f6876454642e1bac3d078c8fc9482' 
          target='_blank' style='font-weight: bold; color: #272445;'>
            Sketchfab
          </a>
        </p>
      </div>


      <div className='model_showcase'>
                                <Iframe 
                                    style='border: 4px solid #d7ddde; background-color: #F2F2F2; padding: 2%; margin: 0px 0px 0px 0px;' 
                                    title='parthenon' 
                                    frameborder='0' 
                                    allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true' 
                                    allow='autoplay; fullscreen; xr-spatial-tracking' 
                                    xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share 
                                    width='420' height='270' 
                                    src='https://sketchfab.com/models/2b3f6876454642e1bac3d078c8fc9482/embed'> 
                                </Iframe>
                                <Iframe 
                                    style='border: 4px solid #d7ddde; background-color: #F2F2F2; padding: 2%; margin: 0px 0px 0px 0px;' 
                                    title='samurai helmet' 
                                    frameborder='0' 
                                    allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true' 
                                    allow='autoplay; fullscreen; xr-spatial-tracking' 
                                    xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share 
                                    width='420' height='270'
                                    src='https://sketchfab.com/models/a315a055e13041dbbbc7a04e5165d1dd/embed'> 
                                </Iframe> 
                                <Iframe 
                                    style='border: 4px solid #d7ddde; background-color: #F2F2F2; padding: 2%; margin: 15px 15px 0% 15px;' 
                                    title='flying ship' 
                                    frameborder='0' 
                                    allowfullscreen mozallowfullscreen='true' webkitallowfullscreen='true' 
                                    allow='autoplay; fullscreen; xr-spatial-tracking' 
                                    xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share 
                                    width='420' height='270'  
                                    src='https://sketchfab.com/models/6f6435fa80f542568774678eedcb8571/embed'> 
                                </Iframe>
                        </div>
*/